/** NPM Packages */
import React, { Component, EventHandler } from 'react';
import { Link } from 'react-router-dom';

/** CSS */
import './copa-form.scss';

/** Components */
import { PolicyPreview } from '../../policy-preview/policy-preview';

interface COPAFormProps
{
	acceptPolicy: ()=>void,
}

interface COPAFormState
{
	canAccept: boolean,
}

export class COPAForm extends Component<COPAFormProps, COPAFormState>
{
	constructor(props:COPAFormProps)
	{
		super(props);
		this.state = {
			canAccept: false,
		}
	}

	private handleClickEvent:EventHandler<any> = this.submit.bind(this);

	private validate() : Promise<any>
	{
		return new Promise((resolve, reject) => {
			if (this.state.canAccept)
			{
				resolve();
			}

			reject();
		});
	}

	private submit(e:MouseEvent) : void
	{
		this.validate()
		.then(() => {
			this.props.acceptPolicy();
		})
		.catch(() => {
			console.warn('User didn\'t accept the privacy policy');
		});
	}

	public userCanAccept() : void
	{
		const updatedState = { ...this.state };
		updatedState.canAccept = true;
		this.setState(updatedState);
	}

	render()
	{
		return (
			<div className="copa-form">
				<h1>Children’s Online Privacy Protection Act Agreement</h1>
				<p>Please read the following policy before clicking the Accept button to continue.</p>
				<PolicyPreview acceptanceCallback={ this.userCanAccept.bind(this) } />
				<div className="-flex-end">
					<Link className="g-button -outline -grey" to="/register/terms-of-use">Back</Link>
					<button onClick={ this.handleClickEvent } className={ (!this.state.canAccept) ? 'g-button is-disabled -primary -solid' : 'g-button -primary -solid' }>Accept</button>
				</div>
			</div>
		);
	}
}
